import { render, staticRenderFns } from "./CustomerSelectModal.vue?vue&type=template&id=04782e8f&scoped=true&"
import script from "./CustomerSelectModal.vue?vue&type=script&lang=js&"
export * from "./CustomerSelectModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelectModal.vue?vue&type=style&index=0&id=04782e8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04782e8f",
  null
  
)

export default component.exports